"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("b-modal", {
    staticClass: "modal-new-prescription",
    attrs: {
      active: true,
      width: 598,
      scroll: "keep",
      "can-cancel": ["escape"],
      "on-cancel": _vm.cancelModal
    }
  }, [_c("div", {
    staticClass: "card"
  }, [_c("div", {
    staticClass: "card-content"
  }, [_c("div", {
    staticClass: "media"
  }, [_c("div", {
    staticClass: "media-content"
  }, [_c("button", {
    staticClass: "btn-x-close",
    attrs: {
      type: "button"
    },
    on: {
      click: _vm.cancelModal
    }
  }, [_c("i", {
    staticClass: "icon-ic_close"
  })]), _vm._v(" "), _c("p", {
    staticClass: "title"
  }, [_vm._v("\n            " + _vm._s(_vm.title) + "\n          ")])])]), _vm._v(" "), _c("div", {
    staticClass: "content"
  }, [_c("form", [_c("b-field", {
    attrs: {
      label: "Nome da prescrição"
    }
  }, [_c("b-input", {
    attrs: {
      placeholder: "Nome",
      required: ""
    },
    model: {
      value: _vm.form.nome,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "nome", $$v);
      },
      expression: "form.nome"
    }
  })], 1), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "Descrição (opcional)"
    }
  }, [_c("b-input", {
    attrs: {
      type: "textarea",
      placeholder: "Descreva de forma breve sobre a prescrição",
      rows: "3"
    },
    model: {
      value: _vm.form.descricao,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "descricao", $$v);
      },
      expression: "form.descricao"
    }
  })], 1), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "Categoria"
    }
  }, [_c("b-select", {
    attrs: {
      placeholder: "Selecione uma categoria",
      required: "",
      expanded: ""
    },
    model: {
      value: _vm.form.categoria,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "categoria", $$v);
      },
      expression: "form.categoria"
    }
  }, [_c("option", {
    attrs: {
      value: ""
    }
  }, [_vm._v("\n                Selecionar\n              ")]), _vm._v(" "), _vm._l(_vm.categorias, function (categoria) {
    return _c("option", {
      key: categoria.value,
      domProps: {
        value: categoria.value
      }
    }, [_vm._v("\n                " + _vm._s(categoria.label) + "\n              ")]);
  })], 2)], 1), _vm._v(" "), _c("div", {
    staticClass: "field"
  }, [_c("label", {
    staticClass: "label"
  }, [_vm._v("Produtos")]), _vm._v(" "), _vm._l(_vm.form.produtos, function (produto, index) {
    return _c("div", {
      key: index,
      staticClass: "product-item"
    }, [_c("div", {
      staticClass: "product-fields"
    }, [_c("b-field", {
      attrs: {
        grouped: ""
      }
    }, [_c("b-field", {
      attrs: {
        label: "Produto",
        expanded: ""
      }
    }, [_c("b-select", {
      attrs: {
        placeholder: "Selecione um produto",
        expanded: ""
      },
      model: {
        value: produto.produtoId,
        callback: function callback($$v) {
          _vm.$set(produto, "produtoId", $$v);
        },
        expression: "produto.produtoId"
      }
    }, [_c("option", {
      attrs: {
        value: ""
      }
    }, [_vm._v("\n                        Selecionar produto\n                      ")]), _vm._v(" "), _vm._l(_vm.produtosDisponiveis, function (prod) {
      return _c("option", {
        key: prod.id,
        domProps: {
          value: prod.id
        }
      }, [_vm._v("\n                        " + _vm._s(prod.name) + "\n                      ")]);
    })], 2)], 1), _vm._v(" "), _c("b-field", {
      attrs: {
        label: "Tipo"
      }
    }, [_c("b-select", {
      staticStyle: {
        "min-width": "100px"
      },
      attrs: {
        placeholder: "Selecione o tipo"
      },
      model: {
        value: produto.tipoAplicacao,
        callback: function callback($$v) {
          _vm.$set(produto, "tipoAplicacao", $$v);
        },
        expression: "produto.tipoAplicacao"
      }
    }, [_c("option", {
      attrs: {
        value: ""
      }
    }, [_vm._v("\n                        Selecione o tipo\n                      ")]), _vm._v(" "), _c("option", {
      attrs: {
        value: "Area",
        title: "Quantidade por hectare"
      }
    }, [_vm._v("\n                        Área\n                      ")]), _vm._v(" "), _c("option", {
      attrs: {
        value: "Volume",
        title: "Quantidade por litro de água"
      }
    }, [_vm._v("\n                        Volume\n                      ")])])], 1), _vm._v(" "), _c("b-field", {
      attrs: {
        label: "Dosagem",
        grouped: ""
      }
    }, [_c("b-input", {
      staticStyle: {
        width: "80px"
      },
      attrs: {
        placeholder: "Ex: 200"
      },
      model: {
        value: produto.dosagem,
        callback: function callback($$v) {
          _vm.$set(produto, "dosagem", $$v);
        },
        expression: "produto.dosagem"
      }
    }), _vm._v(" "), _c("span", {
      staticClass: "dosage-info"
    }, [produto.produtoId && produto.tipoAplicacao && produto.dosagem ? _c("span", {
      staticClass: "type-text"
    }, [_vm._v(_vm._s(_vm.getDosageDescription(produto)))]) : _vm._e()])], 1), _vm._v(" "), _c("b-field", [_c("b-button", {
      staticClass: "remove-product-btn",
      attrs: {
        type: "is-danger",
        "icon-left": "delete",
        disabled: _vm.form.produtos.length === 1
      },
      on: {
        click: function click($event) {
          return _vm.removeProduto(index);
        }
      }
    })], 1)], 1), _vm._v(" "), produto.tipoAplicacao === "Volume" ? _c("b-field", {
      staticStyle: {
        "margin-top": "10px"
      },
      attrs: {
        label: "Volume (L)"
      }
    }, [_c("b-input", {
      staticStyle: {
        width: "150px"
      },
      attrs: {
        placeholder: "Ex: 100",
        type: "number"
      },
      model: {
        value: produto.volume,
        callback: function callback($$v) {
          _vm.$set(produto, "volume", $$v);
        },
        expression: "produto.volume"
      }
    })], 1) : _vm._e()], 1)]);
  }), _vm._v(" "), _c("b-button", {
    staticClass: "add-product-btn",
    attrs: {
      type: "is-light",
      "icon-left": "plus"
    },
    on: {
      click: _vm.addProduto
    }
  }, [_vm._v("\n              Adicionar produto\n            ")])], 2), _vm._v(" "), _c("b-field", {
    staticClass: "row-save-form"
  }, [_c("b-button", {
    staticClass: "btn-save-form",
    on: {
      click: _vm.save
    }
  }, [_vm._v("\n              " + _vm._s(_vm.isEdit ? "Gravar" : "Criar") + "\n            ")])], 1)], 1)])])])]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;